var JS_TABS_SELECTOR = "tabs";
var JS_TRIGGER_SELECTOR = "tabs__trigger";
var JS_TAB_SELECTOR = "tabs-tab";
var JS_TARGET_ATTRIBUTE = "target";
var JS_TAB_ID_ATTRIBUTE = "tab-id";
function tabInit(el) {
    var triggersEls = Array.from(el.querySelectorAll("[data-selector=".concat(JS_TRIGGER_SELECTOR, "]")));
    if (!triggersEls.length) {
        return;
    }
    triggersEls.forEach(function (triggerEl) {
        triggerEl.addEventListener("click", function () {
            var targetId = triggerEl.dataset[JS_TARGET_ATTRIBUTE];
            if (!targetId) {
                return;
            }
            var targetEl = el.querySelector("\n                [data-js-selector=\"".concat(JS_TAB_SELECTOR, "\"][data-").concat(JS_TAB_ID_ATTRIBUTE, "=\"").concat(targetId, "\"]"));
            var tabsEls = Array.from(el.querySelectorAll("[data-js-selector=".concat(JS_TAB_SELECTOR, "]")));
            if (!targetEl || !tabsEls) {
                return;
            }
            tabsEls.forEach(function (tabEl) {
                if (tabEl === targetEl) {
                    tabEl.classList.remove("hidden");
                }
                else {
                    tabEl.classList.add("hidden");
                }
            });
            triggersEls.forEach(function (_triggerEl) {
                if (_triggerEl === triggerEl) {
                    _triggerEl.classList.add("active");
                }
                else {
                    _triggerEl.classList.remove("active");
                }
            });
        });
    });
}
export function tabsInit() {
    var tabsEls = Array.from(document.querySelectorAll("[data-js-selector=".concat(JS_TABS_SELECTOR, "]")));
    window.addEventListener("load", function () {
        if (tabsEls.length > 0) {
            tabsEls.forEach(function (tabEl) {
                tabInit(tabEl);
            });
        }
    });
}
